import { Component, Inject } from '@angular/core';
import { BookingItemConflictService } from '../../services/booking-item-conflict.service';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { BookingItemService } from '../../services/booking-item.service';
import { CONFLICTS_DIALOG } from 'src/testIds';
import { DocumentTitlePipe } from '../../pipes/document-title.pipe';
import { BookingItemNamePipe } from '../../pipes/booking-item-name.pipe';
import { MatButton } from '@angular/material/button';
import { ItemAvailabilityStatsComponent } from '../../item-availability-stats/item-availability-stats.component';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TestIdDirective } from '../../directives/test-id.directive';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

interface Data {
  type: 'hireItem' | 'bookingItem';
  id: number;
}

interface AvailabilityPayload {
  bookingItemId: number;
  bookingId: number;
}

@Component({
  selector: 'app-booking-conflicts-dialog',
  templateUrl: './booking-conflicts-dialog.component.html',
  providers: [BookingItemConflictService, BookingItemService],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    NgIf,
    NgFor,
    TestIdDirective,
    RouterLink,
    MatIcon,
    ItemAvailabilityStatsComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    AsyncPipe,
    BookingItemNamePipe,
    DocumentTitlePipe
  ]
})
export class BookingConflictsDialogComponent {
  private type = new BehaviorSubject<Data | null>(null);
  private availabilitySource = new BehaviorSubject<AvailabilityPayload | null>(
    null
  );

  testIds = CONFLICTS_DIALOG;
  conflicts$ = this.type.pipe(
    filter((data) => !!data),
    switchMap((data) => this.getDataForType(data.type, data.id)),
    tap((conflicts) => (this.noConflicts = conflicts.length === 0))
  );

  isVirtualProduct = false;
  noConflicts = false;

  availability$ = this.availabilitySource.pipe(
    filter((id) => !!id),
    switchMap(({ bookingItemId, bookingId }) =>
      this.bookingItemService.getAvailability(bookingId, bookingItemId)
    )
  );

  constructor(
    private bookingItemConflictService: BookingItemConflictService,
    private bookingItemService: BookingItemService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isVirtualProduct = data.virtualProduct;
    this.type.next({ id: data.id, type: data.type });
    if (data.bookingId && data.bookingItemId) {
      this.availabilitySource.next({
        bookingId: data.bookingId,
        bookingItemId: data.bookingItemId
      });
    }
  }

  private getDataForType(type, id) {
    if (type === 'bookingItem') {
      return this.bookingItemConflictService.getConflicts(id);
    }
    return this.bookingItemConflictService.getHireItemConflicts(id);
  }
}
